import React from "react";
import {AiOutlineArrowLeft} from "react-icons/ai";
import {Link} from "react-router-dom";
import {
  SpendStep1,
  SpendStep2,
  SpendStep3,
  SpendStep4,
  Success,
  Steps,
} from "../../components/steps";
import {useRegisterContext} from "../../context/ContextProvider";
import "../spend/spend.scss";
import "./purchase.scss";

const Purchase = () => {
  const {activeStyle} = useRegisterContext();
  return (
    <section className="spend__container">
      <div className="container purchase__container-div spend__container-div">
        <div className="top">
          {activeStyle === 1 && (
            <Link to="/">
              <span>
                <AiOutlineArrowLeft />
              </span>
            </Link>
          )}
          <div className="steps__container">
            <Steps isEnding={false} length={6} />
          </div>
        </div>
        <div className="bottom">
          {/* check context to apply active style */}
          {activeStyle === 1 && (
            <SpendStep1 text="What type of Building are you calculating for?" />
          )}
          {activeStyle === 2 && (
            <SpendStep2 text="Tell us the state and city the bulding is located" />
          )}
          {activeStyle === 3 && (
            <SpendStep2 text="How much did you last pay for electricity?" />
          )}
          {activeStyle === 4 && (
            <SpendStep2 text="What date did you start using it?" />
          )}
          {activeStyle === 5 && <SpendStep3 />}
          {activeStyle === 6 && (
            <SpendStep4
              title="Remaining days"
              subtitle="37"
              brSubtitle="days to go"
            />
          )}
          {activeStyle === 7 && <Success />}
        </div>
      </div>
    </section>
  );
};

export default Purchase;
